<div class="container-fluid bulk-box margin-bottom">
  <div class="row">
    <div class="col-auto">
      <p>
        You are about to <b>remove</b> the following permissions from the
        selected {{ selectedUsers.length }} account-users:
      </p>
      <div *ngFor="let permission of permissions; let last = last" class="row">
        <div class="col" [class.margin-bottom]="last">- {{ permission }}</div>
      </div>
    </div>
    <div class="col align-self-end">
      <ngb-alert class="info-text" type="info" [dismissible]="false">
        Inherited permissions will not be removed, for example an Admin's
        permission cannot be removed individually.
      </ngb-alert>
    </div>
  </div>
  <div class="row">
    <div class="col-auto ml-auto button">
      <button
        class="btn btn-primary add-staff-btn"
        (click)="approveChangePermissions.emit()"
      >
        Remove from {{ selectedUsers.length }} account-users
      </button>
    </div>
  </div>
</div>
